import apiClient from "./apiClient";

// Wachtpagina in het (al geopende) tabblad zolang de PDF wordt opgehaald of
// samengevoegd; daarna komt de PDF in hetzelfde tabblad. Stijl zoals de app.
const STATUS_PAGE = `<!doctype html><html><head><meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1"><title>PDF</title><style>
html,body{height:100%;margin:0}
body{display:flex;align-items:center;justify-content:center;color:#fff;
  font-family:"DM Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;
  background:radial-gradient(120% 80% at 50% 0%,#3b2366 0%,#17111f 60%,#0e0b13 100%)}
.card{box-sizing:border-box;width:min(380px,calc(100vw - 32px));padding:32px;border-radius:12px;text-align:center;
  background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);box-shadow:0 8px 32px rgba(0,0,0,.3)}
.spin{width:40px;height:40px;margin:0 auto 24px;box-sizing:border-box;border-radius:50%;
  border:3px solid rgba(255,255,255,.15);border-top-color:#fff;animation:r .9s linear infinite}
@keyframes r{to{transform:rotate(360deg)}}
.icon{display:none;width:40px;height:40px;margin:0 auto 24px;border-radius:50%;line-height:40px;font-size:22px;
  font-weight:600;background:rgba(255,90,90,.15);color:#ff8a8a;border:1px solid rgba(255,90,90,.35)}
.title{margin:0 0 6px;font-size:18px;font-weight:500;line-height:24px}
.sub{margin:0;min-height:20px;font-size:14px;line-height:20px;color:rgba(255,255,255,.6);word-break:break-word}
.bar{height:6px;margin-top:24px;border-radius:3px;background:rgba(255,255,255,.1);overflow:hidden}
.fill{height:100%;width:0;border-radius:3px;background:#fff;box-shadow:0 0 12px rgba(255,255,255,.5);transition:width .3s ease}
.error .spin,.error .bar{display:none}
.error .icon{display:block}
</style></head><body><div class="card" id="card"><div class="spin"></div><div class="icon">!</div>
<p class="title" id="title"></p><p class="sub" id="sub"></p>
<div class="bar" id="bar" hidden><div class="fill" id="fill"></div></div></div></body></html>`;

export const createStatusPage = (win) => {
  try {
    win.document.open();
    win.document.write(STATUS_PAGE);
    win.document.close();
  } catch {
    // tabblad al gesloten
  }
  const el = (id) => {
    try {
      return win.document.getElementById(id);
    } catch {
      return null;
    }
  };
  const set = (id, text) => {
    const e = el(id);
    if (e) e.textContent = text;
  };
  return {
    // fraction: 0..1 toont de balk, null verbergt hem
    update(title, sub = "", fraction = null) {
      set("title", title);
      set("sub", sub);
      const bar = el("bar"), fill = el("fill");
      if (bar && fill) {
        bar.hidden = fraction == null;
        if (fraction != null) fill.style.width = `${Math.round(Math.min(1, Math.max(0, fraction)) * 100)}%`;
      }
    },
    fail(message) {
      el("card")?.classList.add("error");
      set("title", "Could not open PDF");
      set("sub", message);
    },
  };
};

export const handleDownloadFile = async (filePathOrPaths, onError) => {
  try {
    console.log('handleDownloadFile called with:', filePathOrPaths);

    // Handle both single file path (string) and multiple file paths (array)
    let filePaths;
    let isMultiple = false;

    if (Array.isArray(filePathOrPaths)) {
      filePaths = filePathOrPaths;
      isMultiple = true;
    } else if (typeof filePathOrPaths === 'string') {
      filePaths = [filePathOrPaths];
    } else {
      console.log('Invalid input: filePathOrPaths is neither string nor array');
      throw new Error('Invalid input: filePathOrPaths must be a string or array');
    }

    // Validate all file paths
    if (!filePaths || filePaths.length === 0) {
      console.log('No file paths provided');
      throw new Error('No file paths provided');
    }

    for (const filePath of filePaths) {
      if (!filePath || typeof filePath !== 'string' || !filePath.match(/\.pdf$/i)) {
        console.log('Invalid filePath:', filePath);
        throw new Error(`Invalid or missing PDF file path: ${filePath}`);
      }
    }

    if (isMultiple) {
      console.log(`Processing ${filePaths.length} PDF files for merging:`, filePaths);
    } else {
      console.log('Processing single PDF file:', filePaths[0]);
    }

    // Prepare the request body
    const requestBody = isMultiple ? { filePaths } : { filePath: filePaths[0] };
    console.log('Prepared requestBody:', requestBody);
    const requestBodyJson = JSON.stringify(requestBody);
    console.log('JSON stringified body:', requestBodyJson);

    // Validate JSON
    if (!requestBodyJson || requestBodyJson === '{}') {
      console.log('Empty or invalid JSON body');
      throw new Error('Failed to create valid request body');
    }

    const organizationId = localStorage.getItem('organization_id');
    const payload = {
      ...JSON.parse(requestBodyJson),
      organizationId: parseInt(organizationId, 10),
    };
    const response = await apiClient.post('/files', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });


    if (response.status !== 200 && response.status !== 201) {

      const errorText =
        typeof response.data === 'string'
          ? response.data
          : JSON.stringify(response.data) || response.statusText || 'Unknown error';


      console.log(`POST /files failed with status ${response.status}:`, errorText);
      throw new Error(`Server responded with status ${response.status}: ${errorText}`);
    }

    const data = response.data;
    console.log('POST /files response:', data);

    if (data.url) {
      const token = localStorage.getItem('token');
      const organizationId = localStorage.getItem('organization_id'); // or wherever you store it

      const pdfResponse = await apiClient.get(`${data.url}?organizationId=${organizationId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });


      const blob = new Blob([pdfResponse.data], { type: 'text/html' });
      const blobUrl = URL.createObjectURL(blob);

      const newWindow = window.open(blobUrl, '_blank');
      if (!newWindow) {
        URL.revokeObjectURL(blobUrl);
        throw new Error('Pop-up blocked. Please allow pop-ups for this site to view PDFs.');
      }
      // Blob-URL vrijgeven zodra de nieuwe tab hem geladen heeft, anders blijft
      // de (samengevoegde) PDF in het geheugen van deze tab hangen. Zelfde
      // 60s-marge als in usePdfCanvasViewer.
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);

      return true;
    } else {
      console.log('No URL in response:', data);
      throw new Error(data.error || 'Failed to retrieve PDF');
    }
  } catch (error) {
    console.error('Error opening PDF:', error.message);
    onError(`Failed to open PDF: ${error.message}`);
    return false;
  }
};